function requestAPI(reviewId, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}review-product/hide/${reviewId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionHideReviewProduct(reviewId) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'HIDE_REVIEW_PRODUCT_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(reviewId, token)
      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'HIDE_REVIEW_PRODUCT_SUCCESS',
        payload: result.data,
        success: {
          message: result.message
        }
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'HIDE_REVIEW_PRODUCT_FAILURE',        
    error: error    
  })
}
